// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chat-bubble-left-right.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chat-bubble-left-right'

import { Icon, type IconComponentProps } from '../icon'

export const ChatBubbleLeftRightIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
